<template>
    <van-tabbar route fixed z-index="999" active-color="#333" inactive-color="#666">
        <van-tabbar-item replace v-for="(item, i) in footerList" :key="i" :to="item.url">
            <template #icon="props">
                <img
                    :src="
                        props.active
                            ? require('@images/tabs/' + item.icon2 + '.png')
                            : require('@images/tabs/' + item.icon1 + '.png')
                    "
                />
            </template>
            {{ item.name }}
        </van-tabbar-item>
    </van-tabbar>
</template>
<script>
export default {
    name: 'Footer',
    props: {},
    components: {},
    data: function() {
        return {
            footerList: [
                {
                    name: '主页',
                    icon1: 'index',
                    icon2: 'index-active',
                    url: '/'
                },
                {
                    name: '课堂瞬间',
                    icon1: 'book',
                    icon2: 'book-active',
                    url: '/classroom'
                },
                {
                    name: '我的',
                    icon1: 'my',
                    icon2: 'my-active',
                    url: '/user'
                }
            ]
        };
    },
    methods: {}
};
</script>
<style scoped>
.yd-tabbar {
    height: 1.05rem;
}
.yd-tabbar .yd-tabbar-item .yd-tabbar-icon .iconfont {
    font-size: 0.4rem;
}
.yd-tabbar .yd-tabbar-item .yd-tabbar-icon .iconfont.icon_vip {
    font-size: 0.45rem;
}
</style>
